// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2JwWB","savePackageButton":"ClientWallet_savePackageButton__1OI_z"};